import { ZoneCard } from "./ZoneCard"
import { Product, SafeZone } from "../types"
import { useApp } from "../context/useApp"
import { getSortedTickets, _, parseNum, getFnbProducts, getEventOccupation } from "../utils/helpers"
import { AddButton } from "./inputs/AddButton"
import { booking, DEFAULT_DIALOG_HANDLE, SCREEN_BREAKPOINT_1 } from "../utils/symbols"
import { Icon } from "./Icon"

type ZoneCardWithProductsProps = {
    open: boolean
    onZoneClick: () => unknown
    onProductChange: (product: Product, newQty: number) => unknown
    zone: SafeZone
}

export const ZoneCardWithProducts = ({ open, zone, onZoneClick, onProductChange }: ZoneCardWithProductsProps) => {

    const {
        state: { products, shifts, layout, dialogHandles, screen }
    } = useApp()

    const [adult, child] = getSortedTickets(products, zone)
    const fnbProducts = getFnbProducts(products)
    const productCount = fnbProducts.length
    const dialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    const zoneOccupancy = booking.getZoneOccupancy(zone)
    const availability = getEventOccupation(layout.processedTables, shifts, zone)
    const adultQty = booking.getProductQty(adult?.id)
    const childQty = booking.getProductQty(child?.id)
    // console.log(zone, availability)

    const openDialog = (product: Product, img = true) => {

        dialogHandle.openDialog({
            className: 'product w-100 h-100 df aic jcc',
            dialog: 'product',
            product: product,
            img,
        })
    }

    const adultTicketName = screen.width < SCREEN_BREAKPOINT_1
        ? _("0ab_adult__")
        : _("0ab_adult_t")

    const childrenTicketName = screen.width < SCREEN_BREAKPOINT_1
        ? _("0ab_child__")
        : _("0ab_child_t")

    const menuOnePax = screen.width < SCREEN_BREAKPOINT_1
        ? `1 ${_("0ab_perso__")}`
        : ""

    const menuTwoPax = screen.width < SCREEN_BREAKPOINT_1
        ? `2 ${_("0ab_peopl__")}`
        : ""

    const someProductIsRequired = products.find(p => p.required)
    const adultsInZone = booking.getProductQty(adult?.id)

    return (
        <div className={`zone-card-container zone-${zone}`}>
            <ZoneCard
                onClick={onZoneClick}
                product={adult}
                zone={zone}
                active={open}
                qty={zoneOccupancy}
                availability={getEventOccupation(layout.processedTables, shifts, zone).percentAvailable}
                className={`${zoneOccupancy ? "currently-focused" : ""} alternative`}
            >
            </ZoneCard>
            {open && (
                <div className="zone-card-content mb-6">
                    <div className="zone-card-content-item zone-card-content-tickets mr-6">
                        {screen.width < SCREEN_BREAKPOINT_1 && (
                            <p className="zone-card-content-label text s18-500 mb-7">{_("0ab_ticke__")}</p>
                        )}
                        <div className="df aic jcsb mb-7 zone-card-content-item-box">
                            <p className="text s18-400">{adultTicketName}</p>
                            <div className="df aic jcfe">
                                <p className="text s18-600 mr-5">{parseNum('EUR', adult.price)}</p>
                                <AddButton
                                    onAddButtonClick={newQty => onProductChange(adult, newQty)}
                                    qty={adultQty}
                                    max={availability.available - childQty}
                                />
                            </div>
                        </div>
                        <div className="df aic jcsb zone-card-content-item-box">
                            <p
                                className="text s18-400 df aic zone-card-content-fnb-product-name"
                                onClick={e => openDialog({ ...child, name: childrenTicketName, description: _('3zo_uptoy__') }, false)}
                            >
                                {childrenTicketName}
                                <span>
                                    <Icon icon="info" />
                                </span>
                            </p>
                            <div className="df aic jcfe">
                                <p className="text s18-600 mr-5">{parseNum('EUR', child.price)}</p>
                                <AddButton
                                    onAddButtonClick={newQty => onProductChange(child, newQty)}
                                    qty={childQty}
                                    max={adultsInZone ? availability.available : 0}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="zone-card-content-item zone-card-content-fnb">
                        {screen.width < SCREEN_BREAKPOINT_1 && (
                            <p className="zone-card-content-label text s18-500 mb-7">
                                {_("0ab_menus__")}
                                {
                                    !someProductIsRequired && (
                                        <span className="text s18-400">{" "}({_("0ab_optio__")})</span>
                                    )
                                }
                            </p>
                        )}
                        {
                            fnbProducts.map((product, index) => {

                                const isOnePax = product.name.indexOf("1") !== -1
                                const name = isOnePax ? menuOnePax : menuTwoPax
                                return (
                                    <div className={`df aic jcsb ${index !== productCount - 1 ? "mb-7" : ""}`} key={product.id}>
                                        <p
                                            className="text s18-400 zone-card-content-fnb-product-name c-p"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                openDialog(product)
                                            }}
                                        >
                                            {name || product.name}
                                            {screen.width > SCREEN_BREAKPOINT_1 && !product.required && (<span>{" "}({_("0ab_optio__")})</span>)}
                                            <Icon icon="info" />
                                        </p>
                                        <div className="df aic jcfe">
                                            <p className="text s18-600 mr-5">{parseNum('EUR', product.price)}</p>
                                            <AddButton
                                                onAddButtonClick={newQty => onProductChange(product, newQty)}
                                                qty={booking.getProductQty(product.id)}
                                            />
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            )}
        </div>
    )
}